import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, LinearProgress, TextField } from '@mui/material';
import { AUTH_LEVELS } from '../auth/Authorized';
import { createEmptyBuildingActionCreator } from '../../redux/actions/uploads';
import OrganizationsLoader from '../loaders/OrganizationsLoader';
import OrganizationSelector from '../userMgmt/OrganizationSelector';

import './Upload.css';

const BuildingStubCreator = ({ userOrg, allowOrgSelection, createBuilding, onCreate }) => {
  const [loading, setLoading] = useState(false);
  const [buildingName, setBuildingName] = useState('');
  const [orgId, setOrgId] = useState(userOrg);
  return (
    <div className="UploadView">
      <OrganizationsLoader />
      <div className="upload-section">
        <TextField
          label="Building name"
          value={buildingName}
          onChange={(e) => setBuildingName(e.target.value)}
        />
      </div>
      {allowOrgSelection && (
        <div className="upload-section">
          <span>Organization: </span>
          <OrganizationSelector selected={`${orgId}`} onChange={(e) => setOrgId(e.target.value)} />
        </div>
      )}
      <div className="upload-section">
        {loading ? (
          <LinearProgress color="secondary" />
        ) : (
          <Button
            color="primary"
            variant="contained"
            style={{ verticalAlign: 'middle' }}
            disabled={!buildingName}
            onClick={() => {
              setLoading(true);
              createBuilding(buildingName, orgId).then((data) => {
                setLoading(false);
                setBuildingName('');
                setOrgId(userOrg);
                if (onCreate != null) {
                  onCreate(data.id);
                }
              });
            }}
          >
            Create Building
          </Button>
        )}
      </div>
    </div>
  );
};

export default connect(
  ({ user: { userAuthLevel, orgId } }) => ({
    allowOrgSelection: userAuthLevel <= AUTH_LEVELS.SUPER_ADMIN,
    userOrg: orgId,
  }),
  (dispatch) => ({
    createBuilding: (buildingName, orgId) =>
      dispatch(createEmptyBuildingActionCreator(buildingName, orgId)),
  })
)(BuildingStubCreator);
